import { Star } from "lucide-react";
import React from "react";

function StarReview({ rating, size = 20, padding = "4px", dir = "ltr" }) {
  const totalStars = 5;
  const filledStars = Math.floor(rating);

  return (
    <div className="d-flex align-items-center gap-1" dir={dir}>
      {Array.from({ length: totalStars }).map((_, index) => (
        <span
          key={index}
          style={{ width: size, height: size, padding }}
          className={`star ${index < filledStars ? "filled" : "empty"}`}
        >
          <Star fill="white" stroke="white" />
        </span>
      ))}
    </div>
  );
}

export default StarReview;
